import { STATS_read } from "@/data/permission-types.js";

export const stats = {
  path: "stats",
  name: "stats",
  component: () =>
    import(/* webpackChunkName: "stats" */ "../../views/stats/StatsIndex.vue"),
  meta: {
    requiresAuth: true,
    requiresPermission: true,
  },
  children: [
    {
      path: "visualizer",
      name: "stats-visualizer",
      component: () =>
        import(
          /* webpackChunkName: "stats" */ "../../views/stats/StatsVisualizer.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${STATS_read}`,
      },
    },
    {
      path: "events",
      name: "stats-events",
      component: () =>
        import(
          /* webpackChunkName: "stats" */ "../../views/stats/StatsEvents.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${STATS_read}`,
      },
    },
    {
      path: "config",
      name: "stats-config",
      component: () =>
        import(
          /* webpackChunkName: "stats-config" */ "../../views/stats/StatsConfig.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${STATS_read}`,
      },
      children: [],
    },
  ],
};
